module.exports = __webpack_public_path__ + "static/img/yy1.6eeec36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy1.png
// module id = +4B5
// module chunks = 1